/**
 * Legal Copy
 *
 * Centralized legal text snippets used across Rescue Foodies platform.
 * Based on rescue-foodies-legal-ux-guardrails-bmad.md
 *
 * IMPORTANT: Keep this in sync with Terms & Conditions v1.0 and Privacy Policy v1.0
 * If legal docs change, update this file accordingly.
 */
export const LEGAL_COPY = {
    /**
     * 3.1 Global Layout / Footer
     */
    footer: {
        businessIdentity: (legalEntityName, address) => `Rescue Foodies is operated by ${legalEntityName}, a company registered in the Philippines with office at ${address}. For concerns, email us at rescuefoodies@gmail.com.`,
        marketplaceNotice: 'Marketplace notice: Rescue Foodies is a platform that connects customers with independent food merchants. Merchants are solely responsible for the preparation, safety, quality, and legality of the food they sell.',
        copyright: (year) => `© ${year} Rescue Foodies. All rights reserved.`,
    },
    /**
     * 3.2 Sign-up / Login / Account Creation
     */
    registration: {
        ageAndTermsConfirmation: 'By creating an account, you confirm that you are at least 18 years old and agree to our Terms and Conditions and Privacy Policy.',
        ageConfirmationCheckbox: 'I confirm that I am at least 18 years old',
        termsAcceptanceCheckbox: 'I agree to the Terms and Conditions and Privacy Policy',
    },
    /**
     * 3.3 Merchant Onboarding / Merchant Profile
     */
    merchant: {
        responsibilityReminder: 'Reminder: As a Merchant, you are the seller of all food items you list on Rescue Foodies. You are responsible for complying with applicable food safety, sanitation, and discount laws (including Senior Citizen and PWD discounts).',
    },
    /**
     * 3.4 Product Listing Cards / Search Results
     */
    productListing: {
        surplusBadge: 'Surplus',
        nearExpiryBadge: 'Near-expiry',
        surplusDescription: 'Surplus / near-expiry item. Discounted due to limited remaining shelf life.',
    },
    /**
     * 3.5 Product Detail / Offer Detail Page
     */
    productDetail: {
        marketplaceNotice: (merchantName) => `Marketplace: This item is sold by ${merchantName} via the Rescue Foodies platform.`,
        surplusNotice: 'Surplus food notice: This is a surplus or near-expiry item and is priced accordingly. It is meant to be consumed shortly after pickup and may have limited remaining shelf life.',
        foodSafetyNotice: (merchantName) => `Food safety: ${merchantName} is responsible for food safety at the time of pickup. Please inspect your items upon pickup.`,
        allergyNotice: 'Allergy notice: Ingredients and allergen information are provided by the Merchant and may not list all possible allergens. If you have allergies or dietary restrictions, please check with the Merchant before consuming.',
    },
    /**
     * 3.6 Checkout / Payment / Order Confirmation
     */
    checkout: {
        orderUnderstanding: `By placing this order, you understand that:
• The Merchant is the seller and is responsible for food safety at the time of pickup.
• Items are surplus or near-expiry and should be consumed shortly after pickup.
• You should inspect your items upon pickup and refuse anything that appears unsafe or spoiled.`,
        scPwdDiscountNotice: 'Senior Citizen / PWD discounts: Merchants will apply either the statutory Senior Citizen/PWD discount or the promotional/surplus price, whichever is more favorable, in accordance with Philippine law (no double discounts).',
        paymentDisclaimer: 'Payments are processed securely by our third-party payment partners (e.g., Xendit). Rescue Foodies does not store your full card details.',
    },
    /**
     * 3.7 Pickup Instructions / Order Status
     */
    pickup: {
        inspectionReminder: `Please inspect your items before leaving the store. 
If you see obvious spoilage or issues:
1. Raise the concern with the Merchant immediately; and
2. Contact Rescue Foodies support as soon as possible with photos and your order details.`,
    },
    /**
     * 3.8 Reviews / Ratings
     */
    reviews: {
        userOpinionDisclaimer: 'Reviews and ratings are opinions of individual users and do not represent the views or guarantees of Rescue Foodies.',
    },
    /**
     * 3.9 Location Features (Maps, "Near Me", Discovery)
     */
    location: {
        permissionExplanation: 'Rescue Foodies uses your location to show nearby surplus food offers and pickup points. You can change this anytime in your device settings.',
    },
    /**
     * 3.10 Cookies / Tracking (Web)
     */
    cookies: {
        banner: 'We use cookies to keep you signed in, improve our services, and show relevant offers. By continuing to use this site, you agree to our use of cookies. See our Privacy Policy for more details.',
    },
    /**
     * Links and CTAs
     */
    links: {
        termsAndConditions: '/legal/terms',
        privacyPolicy: '/legal/privacy',
        termsLabel: 'Terms and Conditions',
        privacyLabel: 'Privacy Policy',
        cancellationsAndRefunds: '/legal/refunds', // TODO: Create refunds policy page
        faq: '/help/faq', // TODO: Create FAQ page
    },
};
//# sourceMappingURL=legalCopy.js.map